import { isMockMode, post, simulateDelay } from "../api";
import { setSingleLicenceState } from "../licences/getForUser";

export const setLicenceStateAttribute = (data) => {
	data.results = data?.results.map((user) => ({
		...user,
		email: user.user.email,
		licences: user?.licences?.map(setSingleLicenceState),
	}));

	return data;
};

export const getUsersWithLicences = ({
	orgId,
	includeAvatars = false,
	...rest
}) => {
	if (isMockMode()) {
		const testData = {
			totalAvailable: 0,
			fetchedCount: 0,
			paginationMetadata: {
				pageNo: 0,
				pageSize: 0,
				totalPages: 0,
			},
			skippedCount: 0,
			results: [
				{
					user: {
						id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
						email: "string",
						firstName: "Test",
						lastName: "McTestie",
					},
					role: 0,
					licences: [
						{
							id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
							isRevoked: true,
							isSubEnabled: true,
							offering: {
								id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
								name: "string",
								websiteLinkUrl: "string",
							},
							subscription: {
								id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
								name: "string",
							},
							activeMachine: "string",
							lastUsedAgentString: "string",
							assignedByUser: {
								id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
								email: "string",
								firstName: "string",
								lastName: "string",
							},
							assignedToUser: {
								id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
								email: "string",
								firstName: "string",
								lastName: "string",
							},
							subExpirationUtc: "2026-03-30T00:57:06.154Z",
							assignedDateUtc: "2026-03-30T00:57:06.154Z",
							licenceExpirationUtc: "2026-03-30T00:57:06.154Z",
							lastActivatedUtc: "2026-03-30T00:57:06.154Z",
							cooldownUntilUtc: "2026-03-30T00:57:06.154Z",
							lastUsedUtc: "2026-03-30T00:57:06.154Z",
							state: 0,
						},
					],
					tags: ["string"],
				},
			],
			orgId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		};
		return simulateDelay(100, () => setLicenceStateAttribute(testData));
	}

	return post(`OrgUsers/GetUsersAndLicences`, {
		orgId,
		includeAvatars,
		...rest,
	}).then(setLicenceStateAttribute);
};
